export default __webpack_public_path__ + "static/media/TDSF-1.4acb0bb3.png";